import React, { useState } from "react";
import { Box, Typography, Button, IconButton,TextField,Input, FormControl } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";


const DynamicForm = ({ schemaString }) => {
    let parsedSchema;
    let isValidSchema = true;

    // Try parsing the schema string before calling hooks
    try {
      parsedSchema = JSON.parse(schemaString);
    } catch (error) {
      isValidSchema = false;
    }

    // Ensure useState is always called
    const [formData, setFormData] = useState(
      isValidSchema
        ? Object.fromEntries(
            Object.entries(parsedSchema).map(([key, field]) => [
              key,
              field.value || "",
            ])
          )
        : {}
    );
  // Handle text input change
  const handleInputChange = (fieldName, value) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const [uploadStatus, setUploadStatus] = useState({});

  const handleFileChange = (fieldName, event) => {
    const file = event.target.files[0];
    setFormData((prev) => ({
      ...prev,
      [fieldName]: file, // Store file object
    }));
    setUploadStatus((prev) => ({
      ...prev,
      [fieldName]: file ? "Uploaded" : "Click here to upload", // Update status based on file presence
    }));
  
  };

  return (
    
    <Box
      sx={{ p: 3, maxWidth: 600, border: "1px solid #ccc", borderRadius: 2, overflowY: "auto", 
        maxHeight: 300 }}>
      {Object.entries(schemaString || {}).map(([key, field]) => (
        <Box key={key} mb={2}>
         {field?.type === "text" && (
  <FormControl fullWidth>
    {/* <FormLabel>{key}</FormLabel> */}
    <TextField
      fullWidth
      placeholder={field?.placeholder}
      value={formData?.[key]}
      onChange={(e) => handleInputChange(key, e.target.value)}
    />
  </FormControl>
)}

{field?.type === "file" && (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2,
      padding: 3,
      border: "2px dashed #ccc",
      borderRadius: "12px",
      position: "relative",
      backgroundColor: "#f9f9f9",
      "&:hover": {
        borderColor: "#3f51b5",
        backgroundColor: "#f3f3ff",
      },
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        cursor: "pointer",
      }}
      component="label"
      htmlFor={`file-upload-${key}`}
    >
 {uploadStatus[key] === "Uploaded" ? (
        <>
          <CheckCircleIcon fontSize="large" sx={{ color: "#4caf50" }} />
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              color: "#4caf50",
            }}
          >
            Uploaded
          </Typography>
        </>
      ) : (
        <>
          <UploadFileIcon fontSize="large" sx={{ color: "#3f51b5" }} />
          <Typography
            variant="h6"
            sx={{
              textAlign: "center",
              color: "#3f51b5",
            }}
          >
            Click here to upload
          </Typography>
        </>
      )}
    </Box>

    <Typography
      variant="body2"
      sx={{ color: "#777", fontStyle: "italic", textAlign: "center" }}
    >
      Drag and drop your file or click to browse. Accepted formats: Images, PDF
    </Typography>
    <input
      hidden
      id={`file-upload-${key}`}
      type="file"
      accept="image/*,application/pdf"
      onChange={(e) => handleFileChange(key, e)}
 
    />
  </Box>
)}

          


        </Box>
      ))}
    </Box>
  );
};


export default DynamicForm;